import { apiSelector } from '@ackee/redux-utils';
import type { ApiReducerState } from '@ackee/redux-utils/lib/config';
import { ApiReducerKey, EntityKey } from 'constants/index';

export const selectIncidentApi = (state): ApiReducerState =>
    apiSelector(state, EntityKey.INCIDENTS, ApiReducerKey.SINGLE);

export const selectIncident = (state): any[] => state.entities[EntityKey.INCIDENTS][ApiReducerKey.SINGLE];
